import { ArrowRight } from 'lucide-react';
import { ADVERTISER_REGISTER_URL } from '../lib/links';
import { ctaClass } from '../lib/cta';

export function FinalCTA() {
  return (
    <section className="relative overflow-hidden border-t border-border-soft bg-gradient-to-br from-primary-soft/40 via-surface to-surface">
      <div className="mx-auto max-w-container-lg px-4 py-24 text-center sm:px-6 lg:px-8 lg:py-28">
        <h2 className="mx-auto max-w-2xl font-display text-4xl leading-display tracking-display text-ink sm:text-5xl">
          Ready to put your brand in front of{' '}
          <span className="italic text-primary">people who&apos;ll remember it?</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-lg text-ink-secondary sm:text-xl">
          Start a campaign today, or have a quick conversation first — whichever
          feels right. We move at your pace.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <a href={ADVERTISER_REGISTER_URL} className={ctaClass('primary', 'lg')}>
            Start a campaign
            <ArrowRight className="h-5 w-5" aria-hidden />
          </a>
          <a href="mailto:hello@adspert.io" className={ctaClass('secondary', 'lg')}>
            Talk to our team
          </a>
        </div>
      </div>
    </section>
  );
}
